// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AssignedResourceMonthAllocation  {
    _originalTypeClassName = "Loom.BO.AssignedResourceMonthAllocation";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AssignedResourceMonthAllocation.translate = translateService;
}
this.AssignedResource = new Domain.AssignedResource();
this.Id = null;
this.Month = null;
this.MonthDate = null;
this.WorkableHoursForMonth = null;
this.WorkableDaysForMonth = null;
this.AllocatedHours = null;
this.HoursFromTimesheets = null;
this.Caption = null;
this.Cost = null;
this.EmployeeCaption = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Month:any;
MonthDate:any;
WorkableHoursForMonth:any;
WorkableDaysForMonth:any;
AllocatedHours:any;
HoursFromTimesheets:any;
Caption:any;
Cost:any;
EmployeeCaption:any;
AssignedResource:any;
static setAssignedResource = ($this, value) => {
var oldValue = $this.AssignedResource;
$this.AssignedResource = value;
if (value != null) {
if (oldValue != null) {
Domain.AssignedResource.removeMonthAllocations(oldValue, $this);
}
Domain.AssignedResource.addMonthAllocations(value, $this);
}
}

static CalculateCost($this: any): any{$this.Cost = Domain.AssignedResourceMonthAllocation.GetCost($this);
}
static GetCaption($this: any): any{return CLMS.Framework.String.Format("M{0} {1}", $this?.Month, CLMS.Framework.DateTime.ToString($this?.MonthDate, "MMM-yyyy"));
}
static GetCost($this: any): any{return Joove.Common.safeNumber($this?.AllocatedHours) * Joove.Common.safeNumber($this?.AssignedResource?.HourlyRate);
}
static GetEmployeeCaption($this: any): any{return Domain.AssignedResource.GetEmployeeCaption($this?.AssignedResource);
}
static GetMonthDate($this: any): any{if ((CLMS.Framework.Number.LessThanOrEqual(() => $this.Month, () => 0))) {return null;}
return Domain.Project.GetMonthDates($this?.AssignedResource?.Project, $this?.Month)[0];
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}